import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { PRODUCT_DETAILS_COLUMNS_CONFIG } from '@app/utils/constants/inventory-item.constant';
import { ProductDetailsEnum } from '@app/utils/enums/inventory-table-columns.enum';
import { InventoryItemFullInformation } from '@app/utils/interfaces/inventory-item.interface';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-product-details-info',
  standalone: true,
  imports: [MatProgressSpinnerModule, TranslatePipe, MatTableModule],
  templateUrl: './product-details-info.component.html',
  styleUrl: './product-details-info.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductDetailsInfoComponent {
  public readonly displayedColumns = Object.values(ProductDetailsEnum);
  public readonly columnsConfig = PRODUCT_DETAILS_COLUMNS_CONFIG;
  public readonly item = input.required<InventoryItemFullInformation>();

  public readonly productDetails = computed(() => this.item()?.productDetails ?? []);
}
